import React from 'react';
import { Outlet } from 'react-router-dom';

import ErrorBoundary from 'components/ErrorBoundary';
import SetupPageAcme from 'containers/SetupPageAcme';
import { useGetStartedTrigger } from 'containers/SetupPageAcme';
import Mixpanel from 'utils/mixpanel';
import useAutoRefresh from 'hooks/useAutoRefresh';

const LayoutDatasets = () => {
  useGetStartedTrigger();
  useAutoRefresh();

  return (
    <>
      <ErrorBoundary>
        <SetupPageAcme />
      </ErrorBoundary>

      <ErrorBoundary>
        <Mixpanel />
      </ErrorBoundary>

      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </>
  );
};
export default LayoutDatasets;
